import Layout from '@/layout/layout'

const PlatFeeManagementRouter = {
    path: '/PlatFeeManagement',
    component: Layout,
    redirect: 'noRedirect',
    name: '平台收费管理',
    children: [
        {
            path: 'feeTypeset',
            component: () => import('@/views/PlatFeeManagement/feeTypeset/index'),
            name: '费用类型设置',
            meta: { title: '费用类型设置', noCache: true }
        },
        {
            path: 'templateSet',
            component: () => import('@/views/PlatFeeManagement/freightWarehouse/templateSet'),
            name: '到仓运费模板设置',
            meta: { title: '到仓运费模板设置', noCache: true }
        },
        {
            path: 'freightTable',
            component: () => import('@/views/PlatFeeManagement/freightWarehouse/freightTable'),
            name: '到仓运费',
            meta: { title: '到仓运费', noCache: true }
        }
    ]
}

export default PlatFeeManagementRouter